import React from 'react';

import Select from '@atlaskit/select';
import Tooltip from '@atlaskit/tooltip';

import { IS_CLOUD } from '@qality/common-config';

export type VersionSelectOption = {
  label: string;
  value: string | number;
};

type Props = {
  onChange: (value: VersionSelectOption) => void;
  onBlur?: () => void;
  autoFocus?: boolean;
  selectValue: VersionSelectOption;
  selectValues: Array<VersionSelectOption>;
  isClearable?: boolean;
  tooltip?: string;
  isDisabled?: boolean;
};

export default function VersionSelect({
  onChange,
  onBlur,
  autoFocus,
  selectValue,
  selectValues,
  isClearable,
  tooltip,
  isDisabled,
}: Props): JSX.Element {
  return (
    <Tooltip testId='tooltip' content={isDisabled && tooltip ? tooltip : ''}>
      <div className='hide-focus-wrapper'>
        <Select
          testId='version-select'
          isClearable={isClearable}
          className='version-select'
          classNamePrefix='solkit'
          placeholder='Search version...'
          options={selectValues}
          value={selectValue}
          onChange={onChange}
          onBlur={onBlur}
          autoFocus={autoFocus ?? false}
          isDisabled={isDisabled ?? false}
          blurInputOnSelect={true}
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999,
              transform: IS_CLOUD ? 'translate(-10px, -30px)' : base.transform,
            }),
          }}
        />
      </div>
    </Tooltip>
  );
}
